import CanvasJSReact from './canvasjs.react';
export const CanvasJS = CanvasJSReact.CanvasJS;
export const CanvasJSChart = CanvasJSReact.CanvasJSChart;